

module.exports = __webpack_require__.stylable.create(
    "ratiobox2012394676",
    {"classes":{"root":"ratiobox2012394676__root","ratio":"ratiobox2012394676__ratio","ratioElement":"ratiobox2012394676__ratioElement","children":"ratiobox2012394676__children"},"vars":{"width":"--ratiobox2012394676-width","height":"--ratiobox2012394676-height"},"stVars":{},"keyframes":{}},
    "",
    1,
    /*! ../node_modules/@wix/search-box-v2/dist/src/components/RatioBox/RatioBox.st.css */ 1302,
    null
);
